

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.-AGTfk4T.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/Cl8rW3gV.js","_app/immutable/chunks/DM11LlHJ.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/BvDXOag0.js","_app/immutable/chunks/DJU9tcyv.js","_app/immutable/chunks/B5iMIKFo.js","_app/immutable/chunks/CWir8Kn7.js"];
export const stylesheets = [];
export const fonts = [];
